import {
    Box,
    Typography,
} from "@mui/material";
import { COLORS } from "../../../dashboard/epis-dashboard/configs/config";
export default function Legenda({ itens }){
    const fmt = (n) => (n ?? 0).toLocaleString("pt-BR");
    return (
        <Box sx={{ display: "grid", gap: 0.5, mt: 1.5 }}>
            {itens.map((i) => (
                <Box key={i.label} sx={{ display: "flex", justifyContent: "space-between", marginLeft:6, marginRight:6}}>
                    <Typography variant="body2" sx={{ color: COLORS.tSec }}>
                        <span style={{ color: i.cor }}>●</span> {i.label}
                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: 600, color: COLORS.tPri }}>{fmt(i.valor)}</Typography>
                </Box>
            ))}
        </Box>
    );
}